module.exports = __webpack_public_path__ + "img/win_icon.3a35bedb.svg";